import { ElementType, PropsWithChildren } from "react";

import { listClasses, ListVariants } from "./List.style";

export type ListProps = {
  component?: ElementType;
  className?: string;
} & ListVariants;

export function List(props: PropsWithChildren<ListProps>) {
  const {
    children,
    column,
    component: Component = "ul",
    className,
    ...rest
  } = props;

  return (
    <Component
      {...rest}
      className={listClasses({
        class: className,
        column,
      })}
    >
      {children}
    </Component>
  );
}

export default List;
